import { BrokerTeamList } from '@insurance/api/requests'
import { Table, TableColumnsType, TableProps } from 'antd'
import { SorterResult } from 'antd/es/table/interface'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getActionColumnMenu } from './tableActions'
import { getTableColumns } from './tableColumns'
import { TeamActionsTypes, TeamsActions } from '../TeamsActions'

type Props = {
  broker: number
  data?: BrokerTeamList[]
  triggerSort: (sorter: SorterResult<BrokerTeamList>) => void
  getSortedTableColumns: (
    columns: TableColumnsType<BrokerTeamList>
  ) => TableColumnsType<BrokerTeamList>
} & TableProps<BrokerTeamList>

export const TeamsTable = ({
  data,
  broker,
  triggerSort,
  getSortedTableColumns,
  ...props
}: Props) => {
  const { t } = useTranslation()
  const [modal, setModal] = useState<{
    type: TeamActionsTypes
    data: BrokerTeamList
  } | null>(null)

  const columns = getSortedTableColumns(
    getTableColumns(getActionColumnMenu(setModal, t), t)
  )

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        onChange={(_, __, sorter) =>
          triggerSort(Array.isArray(sorter) ? sorter[0] : sorter)
        }
        scroll={{ x: 'auto' }}
        {...props}
      />

      {modal && (
        <TeamsActions
          broker={broker}
          open
          onCancel={() => setModal(null)}
          onSuccess={() => setModal(null)}
          {...modal}
        />
      )}
    </>
  )
}
